export const generateRemoteUrl = (searchQuery: string, fetchExternal: boolean) => {
  const filters: string[] = [];

  if (searchQuery) {
    filters.push(`search=${encodeURIComponent(searchQuery.toLowerCase())}`);
  }

  if (fetchExternal) {
    filters.push("fetch_external=true");
  }

  return `programs${filters.length > 0 ? `?${filters.join("&")}` : ""}`;
};
